import buildSlider from './slider';

const options = {
  align: 'start',
  containScroll: 'trimSnaps',
  inViewThreshold: 0.2,
  breakpoints: {
    '(min-width: 0px)': {
      active: false,
    },
    '(min-width: 1181px)': {
      active: true,
      slidesToScroll: 1,
    },
  },
};
// specify options here if needed and pass to buildSlider()
buildSlider('.slider-product-categories-overview', options);
